import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.DeviceRestService
 *
 * @description
 * This class contains methods used to retrieve/update information about devices
 * using http requests.
*/
export default class DeviceRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceRestService#create
     * @methodOf rest.services.DeviceRestService
     * @function
     *
     * @description
     * Creates a device.
     *
     * @param {object} devicePayload Device payload
     *
     * @returns {Promise} The promise of the call.
     */
    create(devicePayload) {

        return super.create(devicePayload, 'devices/');

    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceRestService#update
     * @methodOf rest.services.DeviceRestService
     * @function
     *
     * @description
     * Updates a device.
     *
     * @param {number} deviceId Device identifier
     * @param {object} devicePayload Device payload
     *
     * @returns {Promise} The promise of the call.
     */
    update(deviceId, devicePayload) {

        return super.update(deviceId, devicePayload, 'devices/');

    }

    /**
     * @ngdoc function
     * @name rest.services.DeviceRestService#remove
     * @methodOf rest.services.DeviceRestService
     * @function
     *
     * @description
     * Remove a device.
     *
     * @param {number} deviceId Device identifier
     *
     * @returns {Promise} The promise of the call.
     */
    remove(deviceId) {

        return super.remove(deviceId, 'devices/');

    }


    /**
     * @ngdoc function
     * @name rest.services.DeviceRestService#getAllAsync
     * @methodOf rest.services.DeviceRestService
     * @function
     *
     * @description
     * Retrieves all devices.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('devices/');

    }

}

_serviceDependencies.push(DeviceRestService);

angular.module('rest.services')
    .service('DeviceRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/deviceRestService.js